/**
 * Copyright (C) 2025 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */
import ActionCreator from './action-creator';
import { OverlaysContextsEnum } from './maps/reducer';

/**
 * GLOBAL ACTIONS
 * These actions can be used to throughout all slices of the redux store. Use sparingly.
 */

export const ActionCreators = {
  SwitchOverlaysContext: new ActionCreator<'SwitchOverlaysContext', OverlaysContextsEnum>('SwitchOverlaysContext'),

  // No operation action to be used within epics that need to return an action but don't need to do anything
  NoOp: new ActionCreator<'NoOp', any>('NoOp'),
};

export type Action = typeof ActionCreators[keyof typeof ActionCreators];

export function switchOverlaysContext(overlaysContextType: OverlaysContextsEnum) {
  return ActionCreators.SwitchOverlaysContext.create(overlaysContextType);
}
